'use strict';

angular.module('systemOwnerReviewControllers.DecommissionSystems')

.controller('SummaryDecommissionSystemsModalController', ['$scope', 'searchService', 'decommissionSystemsService', function ($scope, searchService, decommissionSystemsService) {

    var todayDate = moment();

    $scope.todayDay = todayDate.date();
    $scope.todayMonth = todayDate.format('MMMM');

    todayDate.add(60, 'days');

    $scope.archivedDay = todayDate.date();
    $scope.archivedMonth = todayDate.format('MMMM');

    todayDate.add(60, 'days');

    $scope.deletionDay = todayDate.date();
    $scope.deletionMonth = todayDate.format('MMMM');

}]);
